import createUpload from '@ai/mss-upload-js'
import { owlAddJsInfo } from '@RootCommon/utils/owl'
import { getLoginShopid, getWebId } from '@RootCommon/utils'
import { getHornConfig } from '@RootCommon/utils/horn'

export interface UploadS3Options {
  type: 'logs' | 'files' | 'dumps'
  day?: number | string
  filePathsList?: string[]
}

async function getUploadDatas (type: UploadS3Options['type'], day?: UploadS3Options['day'], filePathsList?: UploadS3Options['filePathsList']) {
  let buffer: Buffer
  let prefix = ''
  let logText = ''
  switch (type) {
    case 'logs':
      buffer = await window.electronAPI?.getAppLogs?.(day)
      prefix = 'omlog'
      logText = '本地日志上传失败'
      break
    case 'files':
      buffer = await window.electronAPI?.getAppFiles?.(filePathsList)
      prefix = 'omfile'
      logText = '本地文件上传失败'
      break
    case 'dumps':
      buffer = await window.electronAPI?.getAppDumps?.()
      prefix = 'omdump'
      logText = '本地dump文件上传失败'
      break
    default:
      throw new Error('type is required')
  }
  return { buffer, prefix, logText }
}

export default async function uploadS3 (options: UploadS3Options) {
  let typeText = ''
  try {
    const { type, day = 1, filePathsList } = options
    const uuid = getWebId()
    const shopId = getLoginShopid()
    const fileName = uuid ? `${shopId}_${uuid.slice(-6)}` : shopId

    if (type === 'files' && !filePathsList) {
      throw new Error('filePathsList is required for files type')
    }

    // 根据类型获取不同的数据
    const { buffer, prefix, logText } = await getUploadDatas(type, day, filePathsList)
    typeText = logText || `本地${type}文件上传失败`
    // Buffer -> Uint8Array 以兼容 BlobPart
    const blob = new Blob([new Uint8Array(buffer)], { type: 'application/zip' })
    const file = new File([blob], `${prefix}/${fileName}.zip`, { type: 'application/zip' })
    const isTest = ['newtest', 'test'].includes(process.env.AWP_DEPLOY_ENV)

    createUpload({
      file,
      signatureUrl: '/api/operate/device/getNormalUploadSign',
      s3_host: isTest ? undefined : 's3-ap-hongkong.mykeeta.com',
      bucket: 'sailorfempc',
      prefix_type: 's3_style',
      key: file.name,
      isTest,
      onSuccess () {},
      onError (errorMsg) {
        owlAddJsInfo(typeText, { errorMsg })
      },
    }, 1).upload()
  } catch (e) {
    owlAddJsInfo(`本地${options.type || 'null'}文件上传失败`, {
      errorMsg: JSON.stringify(e, Object.getOwnPropertyNames(e), 2),
    })
  }
}

export async function autoUploadS3 () {
  const hornConfig = await getHornConfig()
  const currShopId = getLoginShopid()

  // 处理日志自动上传
  const logConfigs = hornConfig.autoUploadLog || []
  const logMatch = logConfigs.find(item => String(item.shopId) === String(currShopId))

  if (logMatch) {
    // 延时上传，不阻塞主线程
    setTimeout(() => {
      uploadS3({ type: 'logs', day: logMatch.day })
    }, 10000)
  }

  // 处理文件自动上传
  const fileConfigs = hornConfig.autoUploadFile || []
  const fileMatch = fileConfigs.find(item => String(item.shopId) === String(currShopId))

  if (fileMatch) {
    // 延时上传，不阻塞主线程
    setTimeout(() => {
      uploadS3({ type: 'files', filePathsList: fileMatch.filePaths })
    }, 10000)
  }
}

// @ts-ignore
window.omS3Upload = uploadS3